import Vue from "vue";

// base library

import moment from "moment";
import "moment/locale/zh-cn";

import _ from "lodash";
// import "element-ui/lib/theme-chalk/index.css";
import {
  Button as elementButton,
  Option,
  Select,
  Checkbox as elementCheckbox,
  CheckboxGroup as elementCheckboxGroup,
  Switch,
  Dialog,
  Cascader,
  DatePicker,
  InputNumber as elementInputNumber,
  Loading,
  TimePicker,
  Message
} from "element-ui";
Vue.use(elementButton);
Vue.use(Option);
Vue.use(Select);
Vue.use(elementCheckbox);
Vue.use(elementCheckboxGroup);
Vue.use(Switch);
Vue.use(Dialog);
Vue.use(Switch);
Vue.use(Cascader);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(elementInputNumber);
Vue.use(Loading.directive);
Vue.prototype.$ELEMENT = { size: "small" };
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;

// ext library
import { GetQueryString } from "@/utils/utils";

// import '../assets/iconfont3/iconfont.css'
import "../assets/iconfont/iconfont.css";
import "../assets/iconfont2/iconfont.css";
import DataV from "@jiaminghi/data-view";

Vue.use(DataV);

import {
  Button,
  Card,
  Form,
  Input,
  Icon,
  Checkbox,
  Slider,
  Popover,
  InputNumber
} from "ant-design-vue";
Vue.component(Button.name, Button);
Vue.component(Card.name, Card);
Vue.component(Form.name, Form);
Vue.component(Form.Item.name, Form.Item);
Vue.component(Input.name, Input);
Vue.component(Icon.name, Icon);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Slider.name, Slider);
Vue.component(Popover.name, Popover);
Vue.component(InputNumber.name, InputNumber);

let hideHeader = GetQueryString("hideHeader");
Vue.prototype.$hideHeader = hideHeader;
Vue.prototype.$moment = moment;
Vue.prototype.$_ = _;
Vue.prototype.$app_id = 10008;
// Vue.use(Antd)
// Vue.use(ElementUI);
